<template>
  <tr
    :class="[
      'ms-tr',
      dataRow.IsBold ? 'ms-format-bold' : '',
      dataRow.IsItalic ? 'ms-format-italic' : '',
      { 'action-hover': showRowAction && actionInline },
      { 'rowspan-group': dataRow[`rowspan-${groupField[0]}`] },
    ]"
    tabindex="0"
    :indexRow="dataRow.rowIndex || index"
    @keydown="row_keydown"
    v-if="!dataRow.isHide"
  >
    <td
      class="ms-td multiple-cell sticky ms-col-td-multiple"
      v-if="multiple && dataRow[`rowspan-${groupField[0]}`]"
      :rowspan="dataRow[`rowspan-${groupField[0]}`] || 1"
    >
      <ms-checkbox
        :checked="isChecked"
        @input="checkMultiple"
        class="justify-center"
        ref="multiple"
        checkOnly
        :disabled="disabledCheckedMultipleTbody"
        :key="0"
      />
    </td>
    <td
      :key="0"
      v-if="serial && dataRow[`rowspan-${groupField[0]}`]"
      :rowspan="dataRow[`rowspan-${groupField[0]}`] || 1"
      class="ms-td serial text-center"
      :class="{ sticky: hasLockColumn }"
    >
      {{ pageSize * (currentPage - 1) + index + 1 }}
    </td>
    <td
      v-for="(col, index) in columnx"
      :key="col.dataField"
      class="ms-td ms-col-td"
      :class="[
        col.cssCellClass,
        { sticky: col.lock },
        index === columnx?.length - 1 ? 'ms-col-td-last' : '',
      ]"
      :style="styleWidth(col, false)"
      :ref="`td-${col.dataField}`"
      :rowspan="dataRow[`rowspan-${col.dataField}`]"
    >
      <component
        v-if="col.template"
        :is="col.template"
        :data="dataRow"
        :column="col"
        :dataRow="dataRow"
        :col="col"
        :rowSelected="rowSelected"
        :isSelected="isSelected"
      ></component>
      <div v-else-if="col.isSerial" :class="[`justify-center`, col.cssClass]">
        <span>{{ index + 1 }}</span>
      </div>

      <!-- Kiểu Text nhưng có dạng nhiều dòng value= MORE_DETAILS-->
      <div
        v-else-if="dataRow[col.dataField] === 'MORE_DETAILS'"
        :class="[
          `text-${col.align || 'left'}`,
          col.cssClass,
          'text-overflow',
          'icon24',
          'more-rows',
        ]"
        :title="titleToolTip(dataRow, col)"
        data-animation="animated bounceInDown"
        data-toggle="tooltip"
        @click="viewMoreDetails(col, dataRow)"
      >
        <span></span>
      </div>
      <div
        :class="[
          `text-${col.align || 'left'}`,
          col.cssClass,
          'text-overflow',
          $ms.constant.FormatType.Checkbox,
          col.formatType,
        ]"
        :title="titleToolTip(dataRow, col)"
        data-animation="animated bounceInDown"
        data-toggle="tooltip"
        v-else
      >
        <!-- v-tooltip="{ content:titleToolTip(dataRow, col), placement: 'top'}" -->
        <!-- kiểu checkbox -->
        <span
          v-if="col.formatType === $ms.constant.FormatType.Checkbox"
          class="cell-checkbox"
          :ref="`text-${col.dataField}`"
        >
          <div class="icon" :class="{ checked: dataRow[col.dataField] }"></div>
        </span>
        <!-- kiểu html -->
        <div
          v-else-if="col.formatType === $ms.constant.FormatType.Html"
          class="customStyleHtml"
          v-html="dataRow[col.dataField]"
        ></div>
        <span
          v-else
          :class="[`text-${col.align || 'left'}`]"
          :ref="`text-${col.dataField}`"
        >
          {{
            $ms.format.formatData(dataRow[col.dataField], {
              formatType: col.formatType,
              optionFormat: col.optionFormat,
              enumName: col.enum,
            })
          }}
        </span>

        <!-- <div
          :class="['mi', 'mi-24', col.icon.type]"
          v-if="col.icon && col.icon.show(dataRow, col)"
          v-tooltip="{ ...col.icon.tooltip }"
        ></div> -->
      </div>
    </td>
    <td
      :key="100"
      v-if="$slots.widget && dataRow[`rowspan-${groupField[0]}`]"
      class="ms-td widget-item sticky"
      :rowspan="dataRow[`rowspan-${groupField[0]}`] || 1"
    >
      <slot name="widget" />
    </td>
  </tr>
</template>
<script>
export default {
  name: 'msTr',
  components: {},
  props: {
    //Lưu thông tin của các cột
    columns: {},
    //Lưu dữ liệu của dòng
    dataRow: {},
    //Ẩn/hiện cột checkbox tích chọn nhiều cột
    multiple: {
      default: false,
      type: Boolean,
    },
    //Trạng thái tích chọn ở cột multiple
    isSelected: {
      default: false,
      type: Boolean,
    },
    index: {
      default: null,
      type: Number,
    },
    serial: {
      default: false,
      type: Boolean,
    },
    currentPage: {
      default: 1,
      type: Number,
    },
    pageSize: {
      default: 20,
      type: Number,
    },
    rowSelected: {
      default: null,
    },
    rowActions: {
      default: null,
      type: [Object, Array],
    },
    actionInlineCount: {
      type: Number,
    },
    disabledCheckedMultipleTbody: {
      default: false,
      type: [Boolean, Function],
    },
    hasLockColumn: {
      type: Boolean,
      default: false,
    },
    isCheckedAll: {
      default: () => false,
      type: Boolean,
    },
    groupField: {
      default: () => [],
      type: Array,
    },
    /**
     * Có hiển thị row action không
     * Mặc định là false vì hiện tài nhiều nơi đang không dùng base
     */
    isShowRowAction: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    const me = this;
    me.moreText = me.$t('i18nCommon.command.more');
  },
  computed: {
    /**
     * Action hiển thị trên dòng chọn ngay
     */
    actionInline() {
      let result = [],
        actions = this.rowActions;

      if (actions) {
        if (actions.length > this.actionInlineCount) {
          for (let i = 0; i < this.actionInlineCount - 1; i++) {
            result.push(actions[i]);
          }

          result.push({
            command: 'MORE',
            icon: 'more',
            text: this.moreText,
          });
        } else {
          for (let i = 0; i < actions.length; i++) {
            result.push(actions[i]);
          }
        }
      }

      return result;
    },
    /**
     * Action hiển trong more context
     */
    actionContext() {
      let result = [],
        actions = this.rowActions;

      if (actions && actions.length > this.actionInlineCount) {
        for (let i = this.actionInlineCount - 1; i < actions.length; i++) {
          result.push(actions[i]);
        }
      }

      return result;
    },
    /**
     * Nếu có check all sẽ thực hiện check all
     */
    isChecked() {
      const { disabledCheckedMultipleTbody, isCheckedAll, isSelected } = this;
      return disabledCheckedMultipleTbody ? false : isCheckedAll || isSelected;
    },

    columnx() {
      const columns = this.columns.filter((column) => {
        if (this.groupField.includes(column.dataField)) {
          if (this.dataRow[`rowspan-${column.dataField}`]) {
            return true;
          } else {
            return false;
          }
        }
        return true;
      });
      return columns;
    },
  },
  data() {
    return {
      /**
       * Hiển thị row action không
       */
      showRowAction: false,
      /**
       * Style đặt vị trí hiển thị row action
       */
      rowActionStyle: {
        top: 0,
        left: 0,
      },
    };
  },
  methods: {
    //Cập nhật lại độ rộng của cột theo độ rộng cấu hình
    //Created by LTDAT
    styleWidth(col, widget) {
      let rs = {};

      if (col.lock) {
        rs.left = (col.stickyOffset || 0) + 'px';
      }

      if (!widget) {
        rs['max-width'] = col.width + 'px';
      }
      this.$emit('styleColumn', col, this.dataRow, rs);

      return rs;
    },

    drilldownClick(col, dataRow, e) {
      let metaData = {
        col: col,
        dataRow: dataRow,
      };
      this.$emit('drilldownClick', metaData, e);
    },

    //(Click vào các cột có dạng số nhiều.(đại diện cho nhiều dòng chi tiết)
    //Created by TVLOI 22.05.2021
    viewMoreDetails(col, dataRow, e) {
      dataRow.moreDetails = true;
      let metaData = {
        col: col,
        dataRow: dataRow,
      };
      this.$emit('viewMoreDetails', metaData, e);
    },

    //Emit sự kiện ấn phím ra ngoài grid
    //Created by LTDAT(13/06/2020)
    row_keydown(e) {
      const me = this;
      me.$emit('keydown', me.dataRow, e);
    },
    //Sự kiện click vào nút chọn ở cột multiple
    //Created by LTDAT (28.05.2020)
    //NCPHUOC 28/03/2022: emit checkbox event ra ngoài grid
    checkMultiple(e) {
      const me = this;
      const checked =
        e.target.tagName.toLowerCase() === 'input' ? e.target.checked : false;
      me.$emit('clickMultiple', me.dataRow, checked);
    },

    /**
     * Show tooltip cho nội dung cell
     */
    titleToolTip(dataRow, col) {
      return '';
    },
    /**
     * convert html code to text
     */
    stripHtml(source) {
      let output;
      source = source.toString();
      //get rid of HTML tags
      output = source.replace(/<[^>]*>/g, '');
      output = output.replace(/&nbsp;/g, ' ');
      output = output.replace(/\n/g, '; ');
      return output;
    },
    showActionSub(action, event) {
      const me = this;
      if (action.subMenu) {
        let liPersent = event.toElement;
        if (liPersent) {
          while (!liPersent.className.contains('actionSub')) {
            liPersent = liPersent.offsetParent;
          }
          let liPosition = liPersent.getBoundingClientRect(); // Position của thẻ li (action cha)
          let [menuSub] = me.$refs.actionSubMenu; // Position menu sub
          let elSub = menuSub.$el; // element sub
          let elSubPosition = menuSub.$el.getBoundingClientRect(); // Position của menusub
          if (elSub) {
            // gán lại style cho  element sub, đang tạm gán thôi, chưa tính trường hợp dàn lên trên nếu top quá to hoặc dàn sang phải nếu left quá nhỏ
            elSub.style.top = liPosition.top + 'px';
            elSub.style.left = liPosition.left - elSubPosition.width + 'px';
          }
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/components/MsTrViewer.scss';
tr.rowspan-group {
  td.sticky {
    z-index: 1;
  }
}

.ms-format-bold {
  font-weight: $font-weight-bold;
}
.ms-format-italic {
  font-style: italic;
}
</style>
